<!-- 仪表盘chart组件 -->
<template>
  <div class="dashboard-chart" ref="dashboardChart">
  </div>
</template>
<script>
import 'echarts/lib/chart/line';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/title';
import echarts from 'echarts';
import { mapGetters } from 'vuex';

export default {
  name: 'dashboard-chart',
  data() {
    return {
      dashBoardChart: {},
      max: 100,
      min: 0,
    };
  },
  computed: {
    ...mapGetters('Engineering', ['getTreeData']),
    resizekey() {
      return this.$store.state.Engineering.echartResizeKey;
    },
  },
  props: {
    chartData: {
      type: Object,
    },
    topic: {
      type: String,
    },
  },
  watch: {
    resizekey() {
      this.dashBoardChart.resize();
    },
    chartData: {
      handler(newData) {
        const { chartData, dataSources } = newData;
        if (!chartData[0]) {
          return;
        }
        const val = chartData[0].values[0].value;
        const name = dataSources[0].text;
        const dataSourceId = chartData[0].key;
        let { lowerLimit = 0, upperLimit = 0, unit = '' } = this.getTreeData(dataSourceId);
        unit = unit === null ? '' : unit;
        unit = unit.replace('""', '');
        if (val < this.min) {
          this.min = val;
        }
        if (val > this.max) {
          this.max = val;
        }
        // 如果最大值和最小值相等，则设置默认0-100
        if (lowerLimit === upperLimit) {
          lowerLimit = this.min;
          upperLimit = this.max;
        }
        const option = {
          tooltip: {
            formatter: '{a} <br/>{b} : {c}',
          },
          toolbox: {
            feature: {
              restore: {},
              saveAsImage: {
                title: '保存',
              },
            },
            x: 'center',
            y: 'bottom',
          },
          series: [
            {
              name,
              type: 'gauge',
              min: lowerLimit,
              max: upperLimit,
              detail: { formatter: `{value}${unit}` },
              data: [{ value: val, name }],
              radius: '95%',
            },
          ],
        };
        this.setChartOption(option);
      },
      deep: true,
    },
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      // 初始化图表
      if (!this.topic || this.topic === 'default') {
        this.dashBoardChart = echarts.init(this.$refs.dashboardChart);
      } else {
        this.dashBoardChart = echarts.init(this.$refs.dashboardChart, this.topic);
      }
      const option = {
        tooltip: {
          formatter: '{a} <tr/>{b} : {c}',
        },
        toolbox: {
          feature: {
            restore: {},
            saveAsImage: {
              title: '保存',
            },
          },
          x: 'center',
          y: 'bottom',
        },
        series: [
          {
            name: '当前指标',
            type: 'gauge',
            detail: { formatter: '{value}' },
            data: [{ value: 0, name: '' }],
            radius: '95%',
          },
        ],
      };
      this.setChartOption(option);
    },
    setChartOption(option) {
      const self = this;
      self.dashBoardChart.setOption(option, true);
    },
  },
};

</script>
<style lang="scss" scoped>
  .dashboard-chart{
  }
</style>



// WEBPACK FOOTER //
// src/components/common/echarts/DashboardChart.vue